type Translate = (key: string, params?: Record<string, string>) => string;

/** "1 soubor", "2 soubory", "5 souborů" (the form is picked like in `component.eCard.file.*`). */
export const formatFilesCount = (count: number, t: Translate) => {
	const form = count === 1 ? 'one' : count >= 2 && count <= 4 ? 'two' : 'many';
	return t(`component.mzcr.filesCount.${form}`, { count: String(count) });
};

export const formatSize = (bytes: number) =>
	bytes < 1024 * 1024
		? `${Math.max(1, Math.round(bytes / 1024))} kB`
		: `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;
